import type { EquipmentItem, PatStatus, WorkingState } from '@mads/shared'

/**
 * Attention states take the brass secondary; healthy ones take the plum accent
 * or a neutral (spec §2 — the brass is "reserved for attention states").
 */
export function PatTag({ item }: { item: EquipmentItem }) {
  const labels: Record<PatStatus, string> = {
    ok: item.patTestDate ?? 'Tested',
    overdue: 'Overdue',
    missing: 'No record',
    'n/a': '—',
  }

  const classes: Record<PatStatus, string> = {
    ok: 'tag tag-outline',
    overdue: 'tag tag-accent-2',
    missing: 'tag tag-accent-2',
    'n/a': 'tag tag-neutral',
  }

  return <span className={classes[item.patStatus]}>{labels[item.patStatus]}</span>
}

/**
 * One of four states since issue #59. `Not working` and `Not tested` both take
 * the brass, because both are on the dashboard's attention list; `Not
 * applicable` is a neutral dash, because a reel of cable having no working
 * state is not something anybody needs to act on.
 */
const WORKING_TAG_CLASSES: Record<WorkingState, string> = {
  Working: 'tag tag-accent',
  'Not working': 'tag tag-accent-2',
  'Not tested': 'tag tag-accent-2',
  'Not applicable': 'tag tag-neutral',
}

const WORKING_TAG_LABELS: Record<WorkingState, string> = {
  Working: 'Working',
  'Not working': 'Not working',
  'Not tested': 'Not tested',
  'Not applicable': '—',
}

export function WorkingTag({ item }: { item: EquipmentItem }) {
  return (
    <span className={WORKING_TAG_CLASSES[item.workingState]}>
      {WORKING_TAG_LABELS[item.workingState]}
    </span>
  )
}
